import { Component, Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxCheckBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-input-checkbox-el',
  templateUrl: './input-checkbox-el.component.html',
  styleUrls: ['./input-checkbox-el.component.css']
})

@Directive({
  selector: '[checkboxDx]'
})
export class InputCheckboxElComponent implements OnInit {
  @ViewChild('inputCheckBox', { static: false }) inputCheckBOx: ElementRef<HTMLInputElement>;
  @ViewChild('checkboxDx', { static: false }) checkboxDx: DxCheckBoxComponent;

  //https://stackblitz.com/edit/angular-dynamic-form-builder?file=app%2Fdynamic-form-builder%2Fdynamic-form-builder.component.ts

  @Input() fileDataInput: any
  @Input() dataValue: boolean = false;
  @Input() dataInput: any;
  @Input() formGroup
  @Input() tabIndex;
  @Input() isDX: boolean = true

  @Output() checkBoxEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() checkboxEventInitialized: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() checkboxFocusedEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() checkboxFocusOutEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno

  dxOptions

  checked: boolean = false
  constructor(private el: ElementRef) {

    this.focusElement = this.focusElement.bind(this)

  }
  @HostListener('focus')
  onFocus() {
    this.focusElement()
    this.checkboxFocusedEvent.emit();
  }

  @HostListener('blur')

  onBlur() {
    this.checkboxFocusOutEvent.emit();
  }

  ngAfterViewInit() {
    console.log(this.checkboxDx); // Dovrebbe essere definito qui
  }
  ngOnInit() {
    // console.log('dddddddddddd->', this.fileDataInput)
    if (typeof this.dataValue == 'undefined') {
      this.dataValue = this.fileDataInput.defaultValue !== undefined ? this.fileDataInput.defaultValue : false
      this.checked = true;
      let c = this.formGroup.get(this.fileDataInput.dataField)
      c.setValue(this.dataValue)
    }

    if (!this.dataValue) {
      this.dataValue = this.fileDataInput.defaultValue !== undefined ? this.fileDataInput.defaultValue : false
      this.checked = false;
      let c = this.formGroup.get(this.fileDataInput.dataField)
      c.setValue(this.dataValue)
    }
  }

  onCheckboxChange(ev, checkbox) {

    const checkboxValue = checkbox.value;
    if (checkboxValue != '') {
      let c = this.formGroup.get(this.fileDataInput.dataField)
      c.setValue(checkboxValue)

    }

    let event = {
      name: 'checkBoxChange',
      dataField: this.fileDataInput.dataField,
      component: ev.component,
      value: checkboxValue,
      element: ev.element
    }
    this.checkBoxEvent.emit(event);

    if (checkbox.value) {
      this.checked = true
    }


  }

  onCheckboxInitialized(event) {


    if (!event) {
      event = {}
    }

    event.nativeElement = event.element;
    event.dxComponent = event.component;
    event.editorComponent = this;
    event.id = this.fileDataInput.dataField;
    event.value = this.dataValue
    this.checkboxEventInitialized.emit(event)

  }

  public focusElement() {
    if (this.isDX) {
      this.el.nativeElement.focus();
      const dataField = this.fileDataInput.dataField
      let cc = document.getElementById(dataField)

      console.log('focusElement', cc)
      setTimeout(() => {
        this.checkboxDx.instance.focus(); // Focalizza il componente DevExtreme
      });
    }
  }

  checkboxFocused(ev) {

    console.log('dataFocused', ev)
    //this.focusElement()

    this.checkboxFocusedEvent.emit(ev)

  }
  checkboxFocusOut(ev) {
    this.checkboxFocusOutEvent.emit(ev)
  }
}
